import type { ReactElement, ReactNode } from 'react';

interface ProcessNameWithStatusProps {
  name?: string;
  children?: ReactNode;
  className?: string;
}

export function ProcessNameWithStatus({
  name,
  children,
  className = 'flex items-center gap-2',
}: ProcessNameWithStatusProps): ReactElement {
  return (
    <div className={className}>
      <span className="h-2 w-2 rounded-full bg-green-500 animate-pulse shrink-0" />
      {children ?? <span className="text-sm font-medium">{name}</span>}
    </div>
  );
}
